import gql from "graphql-tag";

export const createContent = gql`
  mutation CreateContent($data: ContentCreateInput!) {
    createContent(data: $data) {
      id
    }
  }
`;
